import { useMemo } from 'react'
import { useGetCategories } from 'src/hooks/useGetCategories'
import { CATEGORY_TYPE } from 'src/libs/constant'
import { timeConvertHHmm } from 'src/libs/date'

export function TimeSlotColumn ({ id }) {
  const timeSlots = useGetCategories(CATEGORY_TYPE.CLASS_TIME_SLOT)
  const timeSlot = useMemo(() => {
    return timeSlots?.find?.((item) => item.id === id)
  }, [id, timeSlots])

  return (
    <>
      {timeSlot
        ? [
            timeConvertHHmm(timeSlot.startTime),
            timeConvertHHmm(timeSlot.endTime)
          ].join(' - ')
        : ''}
    </>
  )
}
